<div class="app-header" [ngClass]="{ 'app-header-list': isListPayformsVisible$ | async }" fxLayout="column" fxLayoutAlign="center stretch">
  <xpo-utils-region-banner [showRegion]="true"></xpo-utils-region-banner>
</div>
